"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _order = require("@/api/order");
var _vuePropertyDecorator = require("vue-property-decorator");
var PrintInformationForm = /*#__PURE__*/function (_Vue) {
  function PrintInformationForm() {
    var _this;
    (0, _classCallCheck2.default)(this, PrintInformationForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, PrintInformationForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "disabled", void 0);
    (0, _defineProperty2.default)(_this, "compare", void 0);
    (0, _defineProperty2.default)(_this, "rules", {});
    (0, _defineProperty2.default)(_this, "loading", false);
    return _this;
  }
  (0, _inherits2.default)(PrintInformationForm, _Vue);
  return (0, _createClass2.default)(PrintInformationForm, [{
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var form;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.loading = true;
              form = (0, _objectSpread2.default)({}, this.form);
              _context.next = 5;
              return _order.orderApi.update(this.form.id, {
                order: {
                  printNo: form.printNo,
                  printDate: form.printDate
                }
              });
            case 5:
              this.$emit("submit:ok");
            case 6:
              _context.prev = 6;
              this.loading = false;
              return _context.finish(6);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0,, 6, 9]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], PrintInformationForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], PrintInformationForm.prototype, "disabled", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], PrintInformationForm.prototype, "compare", void 0);
PrintInformationForm = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], PrintInformationForm);
var _default = exports.default = PrintInformationForm;